import React from 'react'
import './DashboradTitle.scss'
import Col from '../../../UIcomponent/Column'
export const DashboradTitle = (props) => {
    return (
        <Col
            xl={24} lg={24} md={24} sm={24} xs={24}
            className='c__Dashboard__Title'
        >
            <Col
                xl={9} lg={9} md={9} sm={9} xs={7}
                className='o__Dashboard__Title__Line'
            ></Col>
            <Col
                xl={6} lg={6} md={6} sm={6} xs={10}
                className='o__Dashboard__Title'
            >
                {props.title}
                </Col>
            <Col
                xl={9} lg={9} md={9} sm={9} xs={7}
                className='o__Dashboard__Title__Line'
            ></Col>
        </Col>
    )
}
export default DashboradTitle

